export const JSONClone = (obj: any): any => {
    return JSON.parse(JSON.stringify(obj));
}